module.exports = __webpack_public_path__ + "img/dumpattenuator_driving.0da88f08.svg";